// extracted by mini-css-extract-plugin
export var bg = "backdrop-module--bg--3wo2v";